import { z } from "zod";
import { ExternalInvitationKind } from "../enum-external-invitation.js";

export const externalInvitationDetailSchema = z.object({
	kind: z.enum([ExternalInvitationKind.EVENT, ExternalInvitationKind.MEETING]),
	id: z.uuid(),
	title: z.string(),
	description: z.string().nullable(),
	start_at: z.iso.datetime(),
	end_at: z.iso.datetime(),
	timezone: z.string(),
	format: z.string(),
	address: z.string().nullable(),
	cover_image: z.string().nullable(),
	community_name: z.string(),
	community_image: z.string().nullable(),
	organizer_name: z.string(),
	status: z.string(),
	cancelled: z.boolean(),
});

export type ExternalInvitationDetail = z.infer<typeof externalInvitationDetailSchema>;
